import React, {useState, useEffect, useMemo, useRef} from "react";
import {
    InputAdornment,
    TextField,

} from "@mui/material";
import {useTranslation} from "react-i18next";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import Grid from "@mui/material/Grid2";
import CountryCodeChooser from "./CountryCodeChooser";
import RayaField from "./RayaField";
import SearchIcon from "@mui/icons-material/Search";
import {Phone} from "lucide-react";

const MobileField = ({setMobile,classes,error,autoFocus = true}) => {
    const { t } = useTranslation();
    const [country,setCountry] = useState('');
    const [number,setNumber] = useState('');
    const inputRef = useRef(null);

    const handleChangeCountry = (country) => {
        setCountry(country);
        if (inputRef.current && !!autoFocus) {
            inputRef.current.focus();
        }
    };
    const handleChangeNumber = (e) => {
        setNumber(e.target.value);
    };
    useEffect(() => {
        setMobile(country,number)
    }, [number,country]);

    return (
        <Grid container spacing={1} justifyContent="center" dir="ltr">
            <Grid item size={{xs:4,sm:3}}>
                <CountryCodeChooser
                    setCountry={handleChangeCountry}
                />
            </Grid>
            <Grid item size={{xs:8,sm:9}}>
                <RayaField
                    fullWidth
                    id="mobile"
                    label={t("mobile")}
                    name="mobile"
                    variant="outlined"
                    dir="ltr"
                    onChange={handleChangeNumber}
                    error={!!error}
                    helperText={error}
                    inputRef={inputRef}
                    slotProps={{
                        input:{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Phone className='lucide-icon-primary'/>
                                </InputAdornment>
                            ),
                        }
                    }}

                />
            </Grid>
        </Grid>
    );
};

export default withStyles(Styles)(MobileField);
